<script lang="ts" context="module">
	export enum RowStatus {
		SUCCESS = 'SUCCESS',
		FAIL = 'FAIL',
		NONE = 'NONE'
	}
</script>

<script lang="ts">
	import { Icon } from '@repo/commons/components'

	type Props = { row: Record<string, string>; key: string }
	let { row, key }: Props = $props()
	const status = $derived(row[key])
	console.log(`status: ${status}, row: ${JSON.stringify(row)}, key: ${key}`)
</script>

<div class="status-container">
	{#if status === RowStatus.SUCCESS}
		<Icon name="success" size="md" variant="success" />
	{:else if status === RowStatus.FAIL}
		<Icon name="testFailure" size="md" variant="danger" />
	{:else if status === RowStatus.NONE}
		<!--Empty-->
	{/if}
</div>

<style>
	.status-container {
		display: flex;
		align-items: center;
		gap: 10px;
		@apply ms-4;
	}
</style>
